import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">DC Cannabis · Informational Hub</p>
        <h1>Stay Informed on Cannabis Policy and Culture</h1>
        <p className="lede">
          Explore the latest updates, legal insights, and educational resources surrounding cannabis 
          policy in your area. Our mission is to provide comprehensive coverage and foster informed 
          discussions about cannabis culture.
        </p>
        <div className="cta-row">
          <a href="/updates" target="_self">
            Latest Policy Updates
          </a>
          <a href="/education" target="_self" className="secondary">
            Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Stay updated with the latest changes in cannabis legislation and regulations affecting 
            your community. Our coverage ensures you are informed about your rights and responsibilities.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Navigate the complexities of cannabis legality in your area. We provide clear and concise 
            information to help you understand the current legal landscape.
          </p>
        </article>
        <article>
          <h2>Educational Insights</h2>
          <p>
            Access a wealth of knowledge on cannabis culture, health benefits, and responsible usage. 
            Our educational content aims to empower you with the information you need.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;